// extracted by mini-css-extract-plugin
export var container = "Accordion-module--container--BGasT";
export var heading = "Accordion-module--heading--dIbiw";
export var toggle = "Accordion-module--toggle--Ww5-m";